import { DateTime, DurationUnit } from 'luxon';

const getTimeRangeString = (timestamp: number, step: DurationUnit, stepSize: number): string => {
  const dateTimeStart = DateTime.fromMillis(timestamp);
  const dateTimeEnd = DateTime.fromMillis(timestamp).plus({ [step]: stepSize });

  const isYearDifferent = !dateTimeStart.hasSame(dateTimeEnd, 'year');
  const isMonthDifferent = !dateTimeStart.hasSame(dateTimeEnd, 'month');
  const isDayDifferent = !dateTimeStart.hasSame(dateTimeEnd, 'day');

  const endDateFormat =
    (isYearDifferent && 'dd MMM yyyy, HH:mm') ||
    (isMonthDifferent && 'dd MMM, HH:mm') ||
    (isDayDifferent && 'dd MMM, HH:mm') ||
    'HH:mm';

  const dateTimeStartString = dateTimeStart.toFormat('dd MMM yyyy, HH:mm');
  const dateTimeEndString = dateTimeEnd.toFormat(endDateFormat);

  return `${dateTimeStartString} - ${dateTimeEndString}`;
};

export default getTimeRangeString;
